// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_ClientUserType.proto

export enum ENUM_ClientUserType {
  CLIENT_USER_TYPE_UNSPECIFIED = 'CLIENT_USER_TYPE_UNSPECIFIED',
  CLIENT_USER_TYPE_RESIDENTIAL_OWNER = 'CLIENT_USER_TYPE_RESIDENTIAL_OWNER',
  CLIENT_USER_TYPE_LANDLORD = 'CLIENT_USER_TYPE_LANDLORD',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
